import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import UmyUi from 'umy-ui'
import 'umy-ui/lib/theme-chalk/index.css';// 引入样式
import '../assets/css/newicon.css'
import '../assets/css/directives.css';
import elDragDialog from "../directives/el-drag-dialog/index.js";
// 在 main.js 中添加以下代码
Vue.directive('el-drag-dialog', elDragDialog); // 确保指令注册

// 修改 Element UI Dialog 的默认行为
ElementUI.Dialog.props.draggable = {
    type: Boolean,
    default: true
};
Vue.mixin({
    components: {
        'el-dialog': {
            extends: ElementUI.Dialog,
            mounted() {
                if (this.$options.name === 'ElDialog' && this.$el) {
                    // 手动触发拖拽逻辑
                    this.$nextTick(() => {
                        const header = this.$el.querySelector('.el-dialog__header');
                        if (header) {
                            // 应用拖拽逻辑（具体实现取决于你的elDragDialog指令）
                            elDragDialog.bind(this.$el, { modifiers: {} }, this);
                        }
                    });
                }
            }
        }
    }
});
ElementUI.Dialog.props.closeOnClickModal.default = false
ElementUI.Message.error = function (message) {
    return ElementUI.Message({
        message: message,
        type: 'error',
        duration: 1000,
    })
}
ElementUI.Message.success = function (message) {
    return ElementUI.Message({
        message: message,
        type: 'success',
        duration: 1000,
    })
}
ElementUI.Message.warning = function (message) {
    return ElementUI.Message({
        message: message,
        type: 'warning',
        duration: 1000,
    })
}
ElementUI.Message.info = function (message) {
    return ElementUI.Message({
        message: message,
        type: 'info',
        duration: 1000,
    })
}
Vue.use(ElementUI);
Vue.use(UmyUi);
Vue.prototype.resetSetItem = function (key, newVal) {
    if (key === 'penetrateOrderId') {
        // 创建一个StorageEvent事件
        var newStorageEvent = document.createEvent('StorageEvent');
        const storage = {
            setItem: function (k, val) {
                sessionStorage.setItem(k, val);

                // 初始化创建的事件
                newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

                // 派发对象
                window.dispatchEvent(newStorageEvent)
            }
        }
        return storage.setItem(key, newVal);
    }
}